import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'enUS',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            enUS: {
                translation: {
                    basic: {
                        
                        email: "Email Address",
                        password: "Password",
                        oldPassword: "Old passord",
                        newPassword: "New passord",
                        oldAndNewPasswordMatch: "New password cannot be your old password",
                        reEnterNewPassword: "Re-enter new password",
                        passwordsNotIdentical: "The new password does not match with reentered password!",
                        newPasswordNotMeetingRequirements: "New password not meeting requirements. Try again.",
                        passwordChangedSuccessfully: "Password changed successfully",
                        goBacktoLogin: "Go back to login",
                        changePassword: "Change password",
                        youMustChangePassword: "You must change old password",
                        loginError: "Error with login",
                        loginWrong: "Wrong username or password, or check user rights",
                        loginMissing: "Missing email or password",
                        passwordMissing: "Missing password",
                        forgotPassword: "Forgot password?",
                        forgotPasswordEmailOk: "If your email is registered in our system, you wil get a link to reset your password.",
                        forgotPasswordEmailError: "Invalid email used. Please use a valid email adress.",
                        rememberMe: "Remember me",
                        login: "Sign in",
                        logout: "Logout",
                        loggedOut: "You are now logged out.",
                        cannotLogout: "Cannot logout. Try again or contact system support.",

                        loading: "Loading",
                        empty: "Empty",

                        text: "Text",

                        message: "Message",
                        missing: "Missing",

                        create: "Create",
                        change: "Change",

                        reset: "Reset",
                        save: "Save",
                        saveDraft: "Save draft",
                        cancel: "Cancel",
                        delete: "Delete",
                        error: "ERROR",
                        browse: "Browse...",
                        edit: "Edit",
                        disable: "Disable",
                        activate: "Activate",
                        isActive: "Is active",
                        isMappedToUser: "Is mapped to user",
                        add: "Add",
                        firstName: "First name",
                        lastName: "Last name",
                        user: "User",
                        users: "Users",
                        addUser: "Add user",
                        errorWithFindingUsers: "Cannot recieve userlist, error from server: ",
                        unknown: "Unknown",
                        noneChosen: "None chosen",

                        document: "Document",
                        documents: "Documents",
                        unexpectedError: "An unexpected error occurred!",
                        noDataForGraph: "No data for graph to show",
                        noRowsWarning: "No rows to show",
                        documentNoFiles: "Document has no files",
                        notAValidNumber: "Not a valid number",

                        currentOrganization: "Current organization",
                        changeOrganization: "Change organization",
                        organization: "Organization",
                        organizationNumber: "Organization number",
                        organizationInfo: "Organization info",

                        fileNotReady: "File not ready for view yet...",
                        fileMissingPages: "Error, file has no pages!",
                        overviewFor: "Overview for",
                        noFiles: "No files to show",

                        people: "People",
                        customer: "Customer",
                        customers: "Customers",
                        addCustomer: "Add customer",
                        modifyCustomer: "Modify customer",
                        supplier: "Supplier",
                        suppliers: "Suppliers",
                        addSupplier: "Add supplier",
                        modifySupplier: "Modify supplier",
                        address: "Address",
                        addressLine1: "Address line 1",
                        addressLine2: "Address line 2",
                        country: "Country",
                        postArea: "Post area",
                        postalCode: "Postal code",
                        businessNumber: "Business number",
                        account: "Account",

                        generalLedger: "General ledger",
                        any: "Any",
                        recentActivity: "Recent activity",
                        id: "Id",
                        assignedTo: "Assgined to",
                        debitAccount: "Debit account",
                        debitVat: "Debit VAT",
                        creditAccount: "Credit account",
                        viewMoreDetails: "View more details",
                        openAll: "Open all",
                        closeAll: "Close all",
                        close: "Close",
                        comment: "Comment",
                        sendTo: "Send to",
                        completed: "Completed",
                        name: "Name",
                        conditions: "Conditions",
                        amountLimit: "Amount limit",
                        pendingDocuments: "Pending documents",
                        postponedDocuments: "Postponed documents",
                        replace: "Replace",
                        creditNote: "Creditnote",
                        invoice: "Invoice",
                        doesNotExist: "Does not exist",

                        crossReference: "Cross reference",

                        contactInfo: "Contact info",
                        paymentInfo: "Payment info",
                        paymentMethods: "Payment methods",
                        generalAccounts: "General accounts",
                        bank: "Bank",
                        bankAccount: "Bank account",
                        accountNumber: "Account number",
                        accountId: "Account id",
                        IBAN: "IBAN",
                        SWIFT: "SWIFT",
                        vatId: "Vat Id",
                        vatSearch: "VAT search",
                        departmentId: "Department Id",
                        departmentSearch: "Department search",
                        projectId: "Project Id",
                        projectSearch: "Project search",
                        errorAccountInput: "Cannot save data, wrong format bank account input",
                        errorSavingOrganization: "Cannot save organization data. Response from server: ",

                        dataSaved: "Data saved",
                        errorData: "Cannot recieve data. Response from server: ",
                        errorDataSave: "Cannot save data. Response from server: ",
                        errorWithOrganization: "Error with current organization. Cannot perform action.",
                        errorFieldMissing: "Error, cannot save result, some required fields are missing",

                        errorActorTypeIsRequired: "Actortype is required",
                        errorNameIsRequired: "Name is required",
                        errorAddress1IsRequired: "Address1 is required",
                        errorCountryIsRequired: "Country is required",
                        errorPostalCodeIsRequired: "Postal code is required",
                        errorPostAreaIsRequired: "Post area is required",
                        errorActorIdMissing: "Actor Id cannot be read",
                        errorCountry: "Error, cannot retrieve country from API",
                        errorCountryMissing: "Error, cannot find selected country in backend!",

                        paymentMethodInputError: "Inputfield to payment method is not valid",
                        onlyNumbersNoSave: "Cannot save, use only numbers in the inputfield!",
                        inputErrors: "Cannot save. Inputfield empty or wrong format",

                        errorWithAccounts: "Cannot recieve accounts. Messagre from server: ",
                        errorWithVat: "Cannot recieve VAT types. Messagre from server: ",

                        cashDifferenceAccountId: "Cash difference account id",
                        giftCardAccountId: "Gift card account id",
                        withdrawnAccountId: "Withdrawn account id",

                        companyRegistered: "Company registered",
                        canCollectVat: "Can collect VAT",
                        logo: "Logo",
                        supportedFileFormatsAre: "Supported file formats are",
                        website: "Website",
                        phone: "Phone",
                        fax: "Fax",

                        addFile: "Add file",
                        invalidFile: "No or invalid file chosen. Choose either an image or pdf file",

                        actorId: "Actor code",
                        actorName: "Actor name",
                        addActor: "Add actor",
                        actorAdded: "Actor added",
                        errorAddActor: "Error, actor not created. Response from server:",
                        actorModified: "Actor modified",
                        errorActorModified: "Error, actor not modified. Response from server",
                        actorType: "Actor type",
                        ledger: "Ledger",

                        errorOrganizationData: "Can not get organizatrion data. Response from server: ",

                        fileUploaded: "File uploaded",
                        errorFile: "Error, cannot upload file. Asnwer from server:",

                        changeCurrency: "Change currency",
                        currencyAmount: "Currency amount",
                        otherCurrency: "Other currency",
                        currencyNo: "CurrencyNo",
                        exchangeRate: "Exchange rate",
                    },
                    home: {
                        outstandingInvoice: "Outstanding invoice",
                        outstanding: "outstanding",
                        invoiceDate: "Invoice date",
                        approver: "Approver",
                        noPendingDocuments: "No pending documents",
                        waitingForYou: "Waiting for you",
                        waitingForOthers: "Waiting for others",
                        newVouchersRecievedInTheLast30days: "Last 30 vouchers recieved",
                        notificationBoard: "Notification board",
                        errorFetchingNotifications: "Error fetching notifications",
                        source: "Source",
                        incidentId: "Incident Id",
                        created: "Created",
                        lastUpdated: "Last updated",
                        resolved: "Resolved?",
                        message: "Message",
                        noNotifications: "No notifications",

                    },
                    approver: {
                        approvers: "Approvers",
                        myDocuments: "My documents",
                        myPreviousDocuments: "My previous documents",
                        allDocuments: "All documents",
                        approvalFlow: "Approval flow",
                        editApprovalFlow: "Edit approval flow",
                        assginFlowStartApproving: "Assign flow and start approving",
                        switchFlow: "Switch flow",
                        reassign: "Reassign",
                        reassignTo: "Reassign to",
                        reject: "Reject",
                        postpone: "Postpone",
                        approve: "Approve",
                        flow: "Flow",
                        addFlow: "Add flow",
                        distributions: "Distributions",
                        approveAndSendTo: "Approve and send to",
                        approveAndSendToMessage: "Using this method temporarily overrides the approval workflow. Using it is not necessary for normal workflow",
                        documentsInQueue: "Documents in queue",
                        invoiceInformation: "Invoice information",
                        selectSupplier: "Select supplier",
                        startApproving: "Start approving",
                        approveDocument: "Approve document",
                        replaceApprover: "Replace approver",
                        oldApprover: "Old approver",
                        replaceWith: "Replace with",
                        nothingToApprove: "No waiting documents to approve",

                        errorWithGettingFlows: "Cannot recieve flows. Response from server: ",

                        errorWithGettingDocuments: "Cannot recieve documents from API. No documents to approve. Error from server: ",
                        errorWithGettingDocument: "Cannot recieve document from API. Error from server: ",
                        errorWithApprovingDocument: "Error with document approver. Document is undefined",
                        errorWithDocumentAmount: "Amount field under invoice information contains illegal characters",
                        errorWithDocumentCid: "CID field under invoice information contains illegal characters",
                        errorWithDistributionAmount: "Amount in one of the distribution lines contains illegal characters",

                        errorSaveDocument: "Cannot save document changes. Response from server: ",
                        errorApprove: "Cannot approve document. Respone from server: ",
                        errorApproveAndSendTo: "Cannot approve and send document to next user. Respone from server: ",
                        errorPostpone: "Cannot postpone document. Respone from server: ",
                        errorAssign: "Cannot assign document. Respone from server: ",
                        erroSwitchFlow: "Cannot switch flow of document. Respone from server: ",
                        errorReject: "Cannot reject document. Respone from server: ",
                        errorStartApproval: "Cannot start approval. Response from server: ",

                        errorPutFlow: "Cannot save flow. Response from server: ",
                        errorDeleteFlow: "Cannot delete flow. Response from server: ",
                        errorAddFlow: "Cannot create flow. Response from server: ",

                        nameEmpty: "Name field cannot be empty!",
                        amountLimitEmpty: "Amount limit field cannot be empty!",
                        noUsers: "Flow must have users. Add one or more users!",

                        errorReplaceUser: "Cannot replace user. Response from server: ",
                        noUserChosen: "No user chosen. Please chose new approver",

                    },
                    dashboard: {
                        awaitingDataEntry: "Awaiting data entry",
                        inProgress: "In progress",
                        awaitingTransfer: "Awaiting transfer",
                    },
                    reports: {
                        result: "Result",
                        reportDate: "Report date",
                        cashRegisterReport: "Cash register report",
                        productGroup: "Product group",
                        paymentMethods: "Payment methods",
                        openEntriesCustomer: "Open entries: Customer",
                        openEntrierSupplier: "Open entries: Supplier",
                        invoiceNo: "InvoiceNo",
                        customerId: "Customer Id",
                        supplierId: "Supplier Id",
                        outstanding: "Outstanding",
                        outstandingOverdue: "Outstanding overdue",
                        remitted: "Remitted",
                        standardText: "Standard text",
                        voucherDate: "Voucher date",
                        voucherNo: "VoucherNo",
                        corrections: "Corrections",
                        description: "Description",
                        generate: "Generate",
                        total: "Total",
                        sumOutstanding: "Sum outstanding",
                        sumOutstandingOverdue: "Sum outstanding overdue",
                        reportDoesNotExist: "Report does not exist for current selection"
                    },
                    sidemenu: {
                        home: "Home",
                        approver: "Approver",
                        dashboard: "Dashboard",
                        invoicing: "Invoicing",
                        reports: "Reports",
                        voucherSearch: "Voucher Search",
                        registerVoucher: "Voucher Registration",
                        customers: "Customers",
                        suppliers: "Suppliers",
                        settings: "Settings",
                        administration: "Administration",
                        welcome: "Welcome",
                        profile: "Profile",
                        companySettings: "Company Settings",
                        help: "Help",
                        language: "Language",
                        cashRegisterSettings: "Cash register settings",
                        productGroups: "Product groups",
                        statisticsFetchingError: "Failed to fetch statistics. Please try again.",
                    },
                    productGroup: {
                        vatRateId: "VatRateId",
                        taxableSales: "Taxable sales",
                        taxableDiscount: "Taxable discount",
                        nonTaxableSales: "Non taxable sales",
                        nonTaxableDiscount: "Non taxable discount",
                        createProductGroup: "Create product group",
                        editProductGroup: "Edit product group",
                    },
                    search: {
                        search: "Search",
                        comment: "Comment",
                        advancedSearch: "Advanced search",
                        status: "Status",
                        invoiceId: "InvoiceId",
                        voucherDate: "Voucher Date",
                        dueDate: "Due Date",
                        amount: "Amount",
                        amountFrom: "Amount from",
                        amountTo: "Amount to",
                        voucherId: "VoucherId",
                        voucherIdFrom: "VoucherId from",
                        voucherIdTo: "VoucherId to",
                        debet: "Debet",
                        debetVat: "Debet VAT",
                        credit: "Credit",
                        creditVat: "Credit VAT",
                        department: "Department",
                        project: "Project",
                        valueDate: "Value Date",
                        type: "Type",
                        created: "Created",
                        freeTextSearch: "Free text search:",
                        moreSearchOptions: "Show search options",
                        lessSearchOptions: "Hide search options",
                        onlyNumbers: "Can only use numbers in this text field!",
                        expandWindow: "Expand window",
                        reduceWindow: "Reduce window",
                        closeWindow: "Close window",
                        documentChoice: "Document Choice",
                        download: "Download PDF",
                        approvals: "Approvals",
                        cid: "CID",
                        excelExport: "Export to Excel",
                        noFile: "Error, cannot open file",
                    },
                    status: {
                        all: "All",
                        transferred: "Transferred",
                        additionTransferred: "Addition transferred",
                        approvalPending: "Approval pending",
                        approvalPostponed: "Approval postponed",
                        awaitingForDataEntry: "Awaiting for data entry",
                        awaitingForTransfer: "Awaiting for transfer",
                        inProgress: "In progress",
                        rejected: "Rejected",
                    },
                    types: {
                        all: "All",
                        incomingInvoice: "Incoming invoice",
                        outgoingInvoice: "Outgoing invoice",
                        banking: "Banking",
                        cash: "Cash",
                        statement: "Statement",
                        addition: "Addition",
                        journalEntries: "Journal entries",
                        miscellaneous: "Miscellaneous",
                    },
                    dateSearch: {
                        date: "Date",
                        year: "Year",
                        month: "Month",
                        week: "Week",
                        day: "Day",
                        from: "From",
                        to: "To",
                        clearFrom: "Clear from date",
                        clearTo: "Clear to date",
                        clearAll: "Clear from and to date",
                        shortkeys: "Shortkeys",
                        chooseYear: "Choose year",
                        chooseMonth: "Choose month",
                        chooseWeek: "Choose week",
                        choosePeriod: "Choose period",
                        thisWeek: "This week",
                        thisMonth: "This month",
                        thisQuarter: "This quarter",
                        thisYear: "This year",
                        lastWeek: "Last week",
                        lastMonth: "Last month",
                        lastQuarter: "Last quarter",
                        lastYear: "Last year",
                        quarter1: "1. quarter",
                        quarter2: "2. quarter",
                        quarter3: "3. quarter",
                        quarter4: "4. quarter",
                        term1: "1. term",
                        term2: "2. term",
                        term3: "3. term",
                        term4: "4. term",
                        term5: "5. term",
                        term6: "6. term",
                        jan: "jan.",
                        feb: "feb.",
                        march: "march",
                        apr: "april",
                        may: "may",
                        june: "june",
                        july: "july",
                        aug: "aug.",
                        sep: "sep.",
                        oct: "oct.",
                        nov: "nov.",
                        dec: "dec.",
                    },
                    muiDatagrid: {
                        columns: "Columns",
                        columnsLabel: "Select columns",
                        columnTitle: "Column title",
                        columnFind: "Find column",
                        showAll: "Show all",
                        hideAll: "Hide all",

                        unsort: "Unsort",
                        sortDesc: "Sort DESC",
                        sortAsc: "Sort ASC",
                        filter: "Filter",
                        hide: "Hide",
                        showColumns: "Show columns",
                        label: "Label",

                        export: "Export",
                        exportLabel: "Export",
                        exportCSV: "Download as CSV",
                        exportPrint: "Print",
                        exportExcel: "Download as Excel",
                    },
                    voucherRegistration: {

                        documentId: "Document id",
                        newDocument: "New document",
                        accrual: "Accrual",
                        accrualOf: "Accrual of",
                        accrualAmount: "Accrual amount",
                        periodAmount: "Amount per period",
                        numberOfPeriods: "Number of periods",
                        periodFrom: "Period from",
                        periodTo: "Period to",
                        invoiceNo: "invoiceNo",

                        accrualMissingLine: "Cannot open accrual. Missing or there are more than one line",
                        accrualMissingFields: "Missing fields, check Amount and Value date",


                        voucherRegistration: "Voucher registration",
                        create: "Create",
                        transfer: "Transfer",
                        transferAll: "Transfer all",
                        undoReject: "Undo reject",
                        move: "Move",
                        moveTo: "Move to",
                        correct: "Correct",
                        incoming: "Incoming",
                        outgoing: "Outgoing",
                        banking: "Banking",
                        journalEntries: "Journal entries",
                        miscellaneous: "Miscellaneous",
                        addition: "Addition",
                        cash: "Cash",
                        statement: "Statement",

                        awaitingDataEntry: "AwaitingDataEntry",
                        inProgress: "In progress",
                        waitingForTransfer: "Waiting for transfer",
                        transferred: "Transferred",
                        rejected: "Rejected",

                        dataEntryLines: "Data entry lines",
                        voucherLines: "Voucher lines",

                        activateFreeJournalEdit: "Activate free journal edit",

                        transferDocuments: "Transfer documents?",
                        undoRejectDocuments: "Undo reject on documents?",
                        moveDocuments: "Move documents?",
                        correctDocuments: "Correct documents?",

                        rejectDocument: "Reject document?",
                        saveDocument: "Save document?",

                        documentSaved: "Document saved",
                        documentDraftSaved: "Document draft saved",
                        documentRejected: "Document rejected",

                        ignoreWarnings: "Ignore warnings",

                        removeCurrency: "Remove currency",

                        errorFetchingCurrencyRate: "Error fetching currency rate. Please try again",

                        errorPrint: "Error, cannot print documents. Answer from server: ",
                        errorTransfer: "Error, cannot transfer documents. Answer from server: ",
                        errorUndoReject: "Error, cannot undo reject. Answer from server: ",
                        errorMove: "Error, cannot move documents. Answer from server: ",
                        errorCorrect: "Error, cannot correct documents. Answer from server: ",

                        errorReject: "Error, cannot reject document. Answer from server: ",
                        errorSaveDraft: "Error, cannot save draft. Answer from server ",
                        errorSave: "Error cannot save. Answer from server",

                        errorDocument: "Error with document",
                        errorLines: "Error with data entry lines. Check for red warnings on inputs",

                        errorDocumentUpdate: "Error, can not update document. Page is closing",
                        errorPreviousDocument: "Error, no more previous documents in the list",

                        errorWithDates: "Error with dates, check date input fields",
                        errorWithFields: "Error with fields. Check voucher lines",

                        errorCidInput: "Character rejectet. Invalid CID",


                    },
                    userProfile: {
                        mobile: "Mobile",
                        mobileNumber: "Mobile Number",
                        telephone: "Telephone",
                        telephoneNumber: "Telephone Number",
                        countryCode: "Country Code",
                        mobileCountryCode: "Mobile Country Code",
                        phoneCountryCode: "Phone Country Code",
                        title: "Title",
                        dateOfBirth: "Date of Birth",
                        userDataIsMissing: "User data is missing",
                        errorSavingUserProfile: "Error saving user profile",
                        errorSavingUserProfilePic: "Error saving user profile picture",
                        profilePicIsMissing: "Profile picture is missing",
                        userIdIsMissing: "User Id is undefined",
                        profileUpdateSuccessfully: "Profile updated successfully!",
                        profilePictureUpdatedSuccessfully: "Profile picture updated successfully!",
                        updateUser: "Update User",
                        removePicture: "Remove picture",
                        selectPicture: "Select picture",
                        loading: "Loading...",
                        errLoadingCountries: "Error loading countries",
                        updateProfilePicture: "Update Profile Picture",
                        uploadImage: "Upload Image",
                        saveData: "Save Data",
                        selectedFile: "Selected File",
                        noProfilePicture: "No profile picture returned",
                        currentPicture: "Current Profile Picture",
                        updateCurrentPicture: "Update current Profile Picture?",
                        noPhotoUploaded: "No Profile Picture Uploaded",
                        errorInvalidImageType: "The file type is not supported",
                    }
                },
                    sourceDocumentWeblink: {
                        orgIdAndDocIdNotProvided: "Organization ID and Document ID must be provided.",
                        unknownError: "An unknown error occurred.",
                    }

                },
            nbNO: {
                translation: {
                    basic: {
                        
                        email: "Epost adresse",
                        password: "Passord",
                        oldPassword: "Gammelt passord",
                        newPassword: "Nytt passord",
                        oldAndNewPasswordMatch: "Nytt passord kan ikke være lik ditt gamle password.",
                        reEnterNewPassword: "Skriv inn nytt passord på nytt",
                        passwordsNotIdentical: "Det nye passordet stemmer ikke med det nye du skrev inn på nytt!",
                        newPasswordNotMeetingRequirements: "Nytt passord møter ikke sikkerhetskravene. Prøv på nytt.",
                        passwordChangedSuccessfully: "Passord er endret!",
                        goBacktoLogin: "Gå tilbake til innlogging",
                        changePassword: "Bytt password",
                        youMustChangePassword: "Du må bytte gammelt passord",
                        loginError: "Feil med login",
                        loginWrong: "Feil brukernavn eller passord, eller sjekk rettigheter.",
                        loginMissing: "Mangler epost eller passord",
                        passwordMissing: "Mangler passord",
                        forgotPassword: "Glemt passord?",
                        forgotPasswordEmailOk: "Dersom eposten din er registrert hos oss, vil du få en lenke til å resette passord.",
                        forgotPasswordEmailError: "Ugyldig epost brukt. Vennligst bruk en gyldig epost adresse.",
                        rememberMe: "Husk meg",
                        login: "Logg inn",
                        logout: "Logg ut",
                        loggedOut: "Du er nå logget ut.",
                        cannotLogout: "Kan ikke logge ut. Prøv igjen eller kontakt systemansvarlig.",

                        loading: "Laster inn",
                        empty: "Tomt",

                        text: "Tekst",

                        message: "Medling",
                        missing: "Mangler",

                        create: "Opprette",
                        change: "Endre",

                        reset: "Reset",
                        save: "Lagre",
                        saveDraft: "Lagre kladd",
                        cancel: "Avbryt",
                        delete: "Slett",
                        error: "FEIL",
                        browse: "Bla gjennom...",
                        edit: "Rediger",
                        disable: "Deaktiver",
                        activate: "Aktiver",
                        isActive: "Er aktiv",
                        isMappedToUser: "Er koblet til bruker",
                        add: "Legg til",
                        firstName: "Fornavn",
                        lastName: "Etternavn",
                        user: "Bruker",
                        users: "Brukere",
                        addUser: "Legg til bruker",
                        errorWithFindingUsers: "Klarer ikke å finne brukere, svar fra server: ",
                        unknown: "Ukjent",
                        noneChosen: "Ingen valgt",

                        document: "Dokument",
                        documents: "Dokumenter",
                        unexpectedError: "En uventet feil oppstod!",
                        noDataForGraph: "Ingen data for graf å vise",
                        noRowsWarning: "Ingen rader å vise",
                        documentNoFiles: "Dokumentet har ingen filer",
                        notAValidNumber: "Ikke et gyldig tall",

                        currentOrganization: "Gjeldende organisasjon",
                        changeOrganization: "Endre organisasjon",
                        organization: "Organisasjon",
                        organizationNumber: "Organisasjonsnummer",
                        organizationInfo: "Organisasjonsinfo",

                        fileNotReady: "Fil ikke klar for visning enda...",
                        fileMissingPages: "Feil, fil inneholder ingen sider!",
                        overviewFor: "Oversikt for",
                        noFiles: "Ingen filer å vise",

                        people: "Brukere",
                        customer: "Kunde",
                        customers: "Kunder",
                        addCustomer: "Legg til kunde",
                        modifyCustomer: "Endre kunde",
                        supplier: "Leverandør",
                        suppliers: "Leverandører",
                        addSupplier: "Legg til leverandør",
                        modifySupplier: "Endre leverandør",
                        address: "Adresse",
                        addressLine1: "Adresselinje 1",
                        addressLine2: "Adresselinje 2",
                        country: "Land",
                        postArea: "Poststed",
                        postalCode: "Postnummer",
                        businessNumber: "Organisasjonsnummer",
                        account: "Konto",

                        generalLedger: "Hovedbok",
                        any: "Alle",
                        recentActivity: "Nylig aktivitet",
                        id: "Id",
                        assignedTo: "Tilegnet til",
                        debitAccount: "Debit konto",
                        debitVat: "Debit MVA",
                        creditAccount: "Credit konto",
                        viewMoreDetails: "Se flere detaljer",
                        openAll: "Åpne alle",
                        closeAll: "Lukk alle",
                        close: "Lukk",
                        comment: "Kommentar",
                        sendTo: "Send til",
                        completed: "Fullført",
                        name: "Navn",
                        conditions: "Betingelser",
                        amountLimit: "Beløpsgrense",
                        pendingDocuments: "Dokumenter på vent",
                        postponedDocuments: "Utsatte dokumenter",
                        replace: "Erstatte",
                        creditNote: "Kreditnota",
                        invoice: "Faktura",
                        doesNotExist: "Finnes ikke",

                        crossReference: "Kryssreferanse",

                        contactInfo: "Kontaktinfo",
                        paymentInfo: "Betalingsinformasjon",
                        paymentMethods: "Betalingsmetoder",
                        generalAccounts: "Generelle kontoer",
                        bank: "Bank",
                        bankAccount: "Bankkonto",
                        accountNumber: "Kontonummer",
                        accountId: "Konto id",
                        IBAN: "IBAN",
                        SWIFT: "SWIFT",
                        vatId: "MVA nummer",
                        vatSearch: "MVA søk",
                        departmentId: "Avdelings Id",
                        departmentSearch: "Avdelingssøk",
                        projectId: "Prosjekt Id",
                        projectSearch: "Prosjektsøk",
                        errorAccountInput: "Kan ikke lagre, feil format på bankkonto",
                        errorSavingOrganization: "Kan ikke lagre organisasjonsdata. Svar fra server: ",

                        dataSaved: "Data lagret",
                        errorData: "Kan ikke hente data. Svar fra server: ",
                        errorDataSave: "Kan ikke lagre data. Svar fra server: ",
                        errorWithOrganization: "Feil med gjeldende organisasjon. Kan ikke utføre handling.",
                        errorFieldMissing: "Feil, kan ikke lagre informasjon, noen nødvendige felt mangler",

                        errorActorTypeIsRequired: "Aktørtype er påkrevd",
                        errorNameIsRequired: "Navn er påkrevd",
                        errorAddress1IsRequired: "Adresse 1 er påkrevd",
                        errorCountryIsRequired: "Lan er påkrevd",
                        errorPostalCodeIsRequired: "Postnummer er påkrevd",
                        errorPostAreaIsRequired: "Postområde er påkrevd",
                        errorActorIdMissing: "Aktør Id kan ikke leses",
                        errorCountry: "Feil, klarer ikke å hente land",
                        errorCountryMissing: "Feil, klarer ikke å finne valgt land i backend!",

                        paymentMethodInputError: "Inputfelt til betalingsmetode er ikke gyldig",
                        onlyNumbersNoSave: "Kan ikke lagre, bruk bare tall i tekstfeltet!",
                        inputErrors: "Kan ikke lagre. Inputfelt tomt eller feil format",

                        errorWithAccounts: "Klarer ikke å hente kontoer. Svar fra server: ",
                        errorWithVat: "Klarer ikke å hente VAT typer. Svar fra server: ",

                        cashDifferenceAccountId: "Kassadifferanse konto id",
                        giftCardAccountId: "Gavekort konto id",
                        withdrawnAccountId: "Uttak konto id",

                        companyRegistered: "Foretaksregistrert",
                        canCollectVat: "MVA registrert",
                        logo: "Logo",
                        supportedFileFormatsAre: "Støttede filformater",
                        website: "Nettside",
                        phone: "Telefon",
                        fax: "Faks",

                        addFile: "Legg til fil",
                        invalidFile: "Ingen eller ugyldig fil valgt. Velg enten en bilde eller pdf fil",

                        actorId: "Aktør kode",
                        actorName: "Aktørnavn",
                        addActor: "Opprett aktør",
                        actorAdded: "Aktør opprettet",
                        errorAddActor: "Feil, aktør ikke opprettet. Svar fra server:",
                        actorModified: "Aktør modifisert",
                        errorActorModified: "Feil, aktør ikke modifisert. Svar fra server",
                        actorType: "Aktørtype",
                        ledger: "Reskontro",

                        errorOrganizationData: "Kan ikke hente organiasjonsdata. Svar fra server: ",

                        fileUploaded: "Fil lastet opp",
                        errorFile: "Feil, kan ikke laste opp fil. Svar fra server:",

                        changeCurrency: "Endre valuta",
                        otherCurrency: "Annen valuta",
                        currencyNo: "ValutaNr",
                        exchangeRate: "Kurs",
                        currencyAmount: "Valuta antall",
                    },
                    home: {
                        outstandingInvoice: "Utestående fakturaer",
                        outstanding: "utestående",
                        invoiceDate: "Fakturadato",
                        approver: "Attestering",
                        noPendingDocuments: "Ingen dokumenter på vent",
                        waitingForYou: "Venter på deg",
                        waitingForOthers: "Venter på andre",
                        newVouchersRecievedInTheLast30days: "Siste 30 billag motatt",
                        notificationBoard: "Varselbord",
                        errorFetchingNotifications: "Feil ved henting av varsler",
                        source: "Kilde",
                        incidentId: "Hendelse Id",
                        created: "Opprettelse",
                        lastUpdated: "Siste oppdatering",
                        resolved: "Løst?",
                        message: "Melding",
                        noNotifications: "Ingen meldinger",
                    },
                    approver: {
                        approvers: "Attesteringer",
                        myDocuments: "Mine dokumenter",
                        myPreviousDocuments: "Mine forrige dokumenter",
                        allDocuments: "Alle dokumenter",
                        approvalFlow: "Attesteringsflyt",
                        editApprovalFlow: "Rediger attesteringsflyt",
                        assginFlowStartApproving: "Tildel flyt og begynn attestering",
                        switchFlow: "Bytt flyt",
                        reassign: "Tilordne",
                        reassignTo: "Tilordne til",
                        reject: "Avvis",
                        postpone: "Utsette",
                        approve: "Godkjenne",
                        flow: "Flyt",
                        addFlow: "Legg til ny flyt",
                        distributions: "Distribusjoner",
                        approveAndSendTo: "Godkjenn og send til",
                        approveAndSendToMessage: "Denne metoden overskriver midlertidig attesteringsflyten. Den er ikke nødvendig for vanlig arbeidsflyt",
                        documentsInQueue: "Dokumenter i kø",
                        invoiceInformation: "Fakturainformasjon",
                        selectSupplier: "Velg leverandør",
                        startApproving: "Begynn attestering",
                        approveDocument: "Attester dokument",
                        replaceApprover: "Erstatte attestant",
                        oldApprover: "Gammel attestant",
                        replaceWith: "Erstatt med",
                        nothingToApprove: "Ingen dokumenter på vent å attestere",

                        errorWithGettingFlows: "Klarer ikke å hente alle flyt. Svar fra server: ",

                        errorWithGettingDocuments: "Kan ikke hente dokumenter fra API. Ingen dokumenter å attestere. Feilmelding fra server: ",
                        errorWithGettingDocument: "Klarer ikke å hente dokument fra API. Svar fra server: ",
                        errorWithApprovingDocument: "Feil med dokument attestering. Dokumentet er udefinert",
                        errorWithDocumentAmount: "Beløpsfeltet under fakturainfomasjon inneholder ulovelige tegn",
                        errorWithDocumentCid: "KID fletet under fakturainfomasjon inneholder ulovelige tegn",
                        errorWithDistributionAmount: "Beløpsfeltet i et av distribusjonslinjene inneholder ulovelige tegn",

                        errorSaveDocument: "Kan ikke lagre dokumentendringer. Svar fra server: ",
                        errorApprove: "Kan ikke godkjenne dokument. Svar fra server: ",
                        errorApproveAndSendTo: "Kan ikke godkjenne og sende til neste bruker. Svar fra server: ",
                        errorPostpone: "Kan ikke utsette dokument. Svar fra server: ",
                        errorAssign: "Kan ikke tildele dokument. Svar fra server: ",
                        erroSwitchFlow: "Kan ikke endre dokumentflyt. Svar fra server: ",
                        errorReject: "Kan ikke avise dokument. Svar fra server: ",
                        errorStartApproval: "Kan ikke starte attestering. Svar fra server: ",

                        errorPutFlow: "Kan ikke lagre flyt. Svar fra server: ",
                        errorDeleteFlow: "Kan ikke slette flyt. Svar fra server: ",
                        errorAddFlow: "Kan ikke lage ny flyt. Svar fra server: ",

                        nameEmpty: "Navnefelt kan ikke være tomt!",
                        amountLimitEmpty: "Beløpsgrense kan ikke stå tomt!",
                        noUsers: "En flyt må ha brukere. Legg til en eller flere brukere.",

                        errorReplaceUser: "Kan ikke ersatte bruker. Svar fra server: ",
                        noUserChosen: "Ingen bruker valgt. Vennligst velg ny attestant",

                    },
                    dashboard: {
                        awaitingDataEntry: "Venter på data",
                        inProgress: "Under behandling",
                        awaitingTransfer: "Venter på overføring",
                    },
                    reports: {
                        result: "Resultat",
                        reportDate: "Rapport dato",
                        cashRegisterReport: "Kassabilagsrapport",
                        productGroup: "Produktgruppe",
                        paymentMethods: "Betalingsmetoder",
                        openEntriesCustomer: "Åpne poster: Kunder",
                        openEntrierSupplier: "Åpne poster: Leverandør",
                        invoiceNo: "FakturaNr",
                        customerId: "KundeId",
                        supplierId: "LeverandørId",
                        outstanding: "Utestående",
                        outstandingOverdue: "Forfalt utestående",
                        remitted: "Remittert",
                        standardText: "Standard tekst",
                        voucherDate: "Bilagsdato",
                        voucherNo: "Bilagsnummer",
                        corrections: "Korreksjoner",
                        description: "Beskrivelse",
                        generate: "Generer",
                        total: "Total",
                        sumOutstanding: "Sum utestående",
                        sumOutstandingOverdue: "Sum forfalt utestående",
                        reportDoesNotExist: "Rapport finnes ikke for gjeldende valg"
                    },
                    sidemenu: {
                        home: "Hjem",
                        approver: "Attestering",
                        dashboard: "Dashboard",
                        invoicing: "Fakturering",
                        reports: "Rapporter",
                        voucherSearch: "Bilagssøk",
                        registerVoucher: "Bilagsregistrering",
                        customers: "Kunder",
                        suppliers: "Leverandører",
                        settings: "Innstillinger",
                        administration: "Administrasjon",
                        welcome: "Velkommen",
                        profile: "Profil",
                        companySettings: "Firmainnstillinger",
                        help: "Hjelp",
                        language: "Språk",
                        cashRegisterSettings: "Kassebilags innstillinger",
                        productGroups: "Produktgrupper",
                        statisticsFetchingError: "Kunne ikke hente statistikk. Vennligst prøv igjen.",
                    },
                    productGroup: {
                        vatRateId: "MVA kode",
                        taxableSales: "Momspliktig salg",
                        taxableDiscount: "Momspliktig rabatt",
                        nonTaxableSales: "Ikke momspliktig salg",
                        nonTaxableDiscount: "Ikke momspliktig rabatt",
                        createProductGroup: "Legg til produktgruppe",
                        editProductGroup: "Rediger produktgruppe",
                        
                    },
                    search: {
                        search: "Søk",
                        comment: "Kommentar",
                        advancedSearch: "Avansert søk",
                        status: "Status",
                        invoiceId: "FakturaNr",
                        voucherDate: "Bilagsdato",
                        dueDate: "Forfallsdato",
                        amount: "Beløp",
                        amountFrom: "Beløp fra",
                        amountTo: "Beløp til",
                        voucherId: "BilagsNr",
                        voucherIdFrom: "BilagsNr fra",
                        voucherIdTo: "BilagsNr til",
                        debet: "Debet",
                        debetVat: "Debet Mva",
                        credit: "Kredit",
                        creditVat: "Kredit Mva",
                        department: "Avdeling",
                        project: "Prosjekt",
                        valueDate: "Valuteringsdato",
                        type: "Type",
                        created: "Opprettet",
                        freeTextSearch: "Fritekst søk:",
                        moreSearchOptions: "Vis søkealternativer ",
                        lessSearchOptions: "Skjul søkealternativer ",
                        onlyNumbers: "Kan bare bruke tall i dette tekstfeltet!",
                        expandWindow: "Utvid visning",
                        reduceWindow: "Reduser visning",
                        closeWindow: "Lukk visning",
                        documentChoice: "Dokumentvalg",
                        download: "Last ned PDF",
                        approvals: "Godkjenningsflyt",
                        cid: "KID",
                        excelExport: "Eksporter til Excel",
                        noFile: "Klarer ikke å åpne fil",
                    },
                    status: {
                        all: "Alle",
                        transferred: "Overført",
                        additionTransferred: "Korreksjon overført",
                        approvalPending: "Aventer godkjenning",
                        approvalPostponed: "Godkjenning utsatt",
                        awaitingForDataEntry: "Venter på datainput",
                        awaitingForTransfer: "Venter på overføring",
                        inProgress: "Behandles",
                        rejected: "Avslått",
                    },
                    types: {
                        all: "Alle",
                        incomingInvoice: "Inngående faktura",
                        outgoingInvoice: "Utgående faktura",
                        banking: "Bank",
                        cash: "Dagsoppgjør",
                        statement: "Kontoutskrift",
                        addition: "Tillegg",
                        journalEntries: "Hovedbok",
                        miscellaneous: "Diverse",
                    },
                    dateSearch: {
                        date: "Dato",
                        year: "År",
                        month: "Måned",
                        week: "Uke",
                        day: "Dag",
                        from: "Fra",
                        to: "Til",
                        clearFrom: "Fjern fra-dato",
                        clearTo: "Fjern til-dato",
                        clearAll: "Fjern fra og til dato",
                        shortkeys: "Hurtigknapper",
                        chooseYear: "Velg år",
                        chooseMonth: "Velg måned",
                        chooseWeek: "Velg uke",
                        choosePeriod: "Velg periode",
                        thisWeek: "Denne uken",
                        thisMonth: "Denne måned",
                        thisQuarter: "Dette kvartal",
                        thisYear: "Dette år",
                        lastWeek: "Forrige uke",
                        lastMonth: "Forrige måned",
                        lastQuarter: "Forrige kvartal",
                        lastYear: "Forrige år",
                        quarter1: "1. kvartal",
                        quarter2: "2. kvartal",
                        quarter3: "3. kvartal",
                        quarter4: "4. kvartal",
                        term1: "1. termin",
                        term2: "2. termin",
                        term3: "3. termin",
                        term4: "4. termin",
                        term5: "5. termin",
                        term6: "6. termin",
                        jan: "jan.",
                        feb: "feb.",
                        march: "mars",
                        apr: "april",
                        may: "mai",
                        june: "juni",
                        july: "july",
                        aug: "aug.",
                        sep: "sep.",
                        oct: "okt.",
                        nov: "nov.",
                        dec: "des.",
                    },

                    muiDatagrid: {
                        columns: "Kolonner",
                        columnsLabel: "Velg kolonner",
                        columnTitle: "Kolonnetittel",
                        columnFind: "Finn kolonne",
                        showAll: "Vis alle",
                        hideAll: "Skjul alle",

                        unsort: "Fjern filter",
                        sortDesc: "Sorter synkende",
                        sortAsc: "Sorter stigende",
                        filter: "Filtrere",
                        hide: "Skjul",
                        showColumns: "Vis kolonner",
                        label: "Etikett",

                        export: "Eksporter",
                        exportLabel: "Eksporter",
                        exportCSV: "Last ned som CSV",
                        exportPrint: "Print",
                        exportExcel: "Last ned som Excel",
                    },

                    voucherRegistration: {

                        documentId: "Dokument id",
                        newDocument: "Nytt dokument",
                        accrual: "Periodisering",
                        accrualOf: "Periodisering av",
                        accrualAmount: "Periodiseringsbeløp",
                        periodAmount: "Beløp per periode",
                        numberOfPeriods: "Antall perioder",
                        periodFrom: "Periode fra",
                        periodTo: "Periode til",
                        invoiceNo: "fakturaNr",

                        accrualMissingLine: "Kan ikke åpne periodisering. Mangler eller det er flere enn en linje",
                        accrualMissingFields: "Manglende felter, sjekkt beløp eller valuteringsdato",

                        voucherRegistration: "Bilagsregistrering",
                        create: "Opprett",
                        transfer: "Overfør",
                        transferAll: "Overfør alle",
                        undoReject: "Angre avvisning",
                        move: "Flytt",
                        moveTo: "Flytt til",
                        correct: "Korriger",
                        incoming: "Inngående",
                        outgoing: "Utgående",
                        banking: "Bank",
                        journalEntries: "Hovedbok",
                        miscellaneous: "Diverse",
                        addition: "Korreksjoner",
                        cash: "Dagsoppgjør",
                        statement: "Kontoutskrift",

                        awaitingDataEntry: "Venter på data",
                        inProgress: "Behandles",
                        waitingForTransfer: "Venter på overføring",
                        transferred: "Overført",
                        rejected: "Avvist",

                        dataEntryLines: "Bilagslinjer",
                        voucherLines: "Fakturalinjer",
                        activateFreeJournalEdit: "Aktiver fri føring",

                        transferDocuments: "Overfør dokumenter?",
                        undoRejectDocuments: "Angre avvisning på dokumenter?",
                        moveDocuments: "Flytte dokumenter?",
                        correctDocuments: "Korriger dokumenter?",

                        rejectDocument: "Avvis dokument?",
                        saveDocument: "Lagre dokument?",

                        documentSaved: "Dokument lagret",
                        documentDraftSaved: "Dokumentkladd lagret",
                        documentRejected: "Dokument avvist",

                        ignoreWarnings: "Ignorer advarsler",

                        removeCurrency: "Fjern valuta",

                        errorFetchingCurrencyRate: "Feil ved henting av valutakurs. Vennligst prøv igjen",

                        errorPrint: "Feil, kan ikke overføre dokumenter. Svar fra server: ",
                        errorTransfer: "Feil, kan ikke overføre dokumenter. Svar fra server: ",
                        errorUndoReject: "Feil, kan ikke angre avvisning. Svar fra server: ",
                        errorMove: "Feil, kan ikke flytte dokumenter. Svar fra server: ",
                        errorCorrect: "Feil, kan ikke korrigere dokumenter. Svar fra server: ",

                        errorReject: "Feil, kan ikke avvsie dokument. Svar fra server: ",
                        errorSaveDraft: "Feil, kan lagre kladd. Svar fra server: ",
                        errorSave: "Feil, kan ikke lagre dokument. Svar fra server: ",

                        errorDocument: "Feil med dokument",
                        errorLines: "Feil med bilagslinjer. Se etter rødt merket inputfelt",

                        errorDocumentUpdate: "Feil, kan ikke oppdatere dokument. Siden lukkes",

                        errorWithDates: "Feil med dato, sjekk dato input felt",
                        errorWithFields: "Feil med felter. Sjekk bilagslinjer",

                        errorCidInput: "Tegn avslått. Ugyldig KID",

                    },
                    userProfile: {

                        mobile: "Mobil",
                        mobilNumber: "Mobilnummer",
                        telephone: "Telefon",
                        telephoneNumber: "Telefonnummer",
                        mobileCountryCode: "Landskode mobil",
                        phoneCountryCode: "Landskode telefon",
                        countryCode: "Landskode",
                        title: "Tittel",
                        dateOfBirth: "Fødselsdato",
                        userDataIsMissing: "Brukerdata mangler",
                        errorSavingUserProfile: "Feil ved lagring av brukerprofil",
                        errorSavingUserProfilePic: "Feil ved lagring av profilbilde",
                        profilePicIsMissing: "Profilbilde mangler",
                        userIdIsMissing: "Bruker-ID er ikke definert",
                        profileUpdateSuccessfully: "Profil oppdatert vellykket!",
                        profilePictureUpdatedSuccessfully: "Profilbilde oppdatert vellykket!",
                        updateUser: "Oppdater Bruker",
                        removePicture: "Fjern bilde",
                        selectPicture: "Velg bilde",
                        loading: "Laster...",
                        errLoadingCountries: "Feil ved lasting av land",
                        updateProfilePicture: "Oppdater Profilbilde",
                        uploadImage: "Opplast Bilde",
                        saveData: "Lagre Data",
                        selectedFile: "Valgt Fil",
                        noProfilePicture: "Ingen profilbilde returnert",
                        currentPicture: "Nåværende Profilbilde",
                        updateCurrentPicture: "Oppdater nåværende Profilbilde?",
                        noPhotoUploaded: "Ingen Profilbilde Opplastet",
                        errorInvalidImageType: "Filtypen støttes ikke",
                    },

                    sourceDocumentWeblink: {
                        orgIdAndDocIdNotProvided: "OrganisasjonsId og DocumentId mangler",
                        unknownError: "Ukjent feil har oppstått",
                    }
                }
            }
        }
    });

export default i18n;